export default "__VITE_ASSET__Dhw4gEVg__"